module.exports = __webpack_public_path__ + "static/media/Rectangle 73.d8384202.png";